import React from "react";
import { Box } from "@mui/material";
import { confettiAnimation } from "../animations";

const ConfettiPiece: React.FC<{ delay: number; color: string; left: number }> = ({ delay, color, left }) => (
  <Box
    sx={{
      position: "absolute",
      width: 8,
      height: 8,
      backgroundColor: color,
      borderRadius: "2px",
      left: `${left}%`,
      bottom: 0,
      animation: `${confettiAnimation} 1s ease-out ${delay}s forwards`,
    }}
  />
);

export const Confetti: React.FC<{ show: boolean }> = ({ show }) => {
  if (!show) return null;

  const colors = ["#4caf50", "#2196f3", "#ff9800", "#e91e63", "#9c27b0"];
  const pieces = Array.from({ length: 15 }, (_, i) => ({
    delay: Math.random() * 0.3,
    color: colors[i % colors.length],
    left: Math.random() * 100,
  }));

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      {pieces.map((piece, i) => (
        <ConfettiPiece key={i} {...piece} />
      ))}
    </Box>
  );
};
